import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CoachesDataService, CoachesColumnsService } from '../../../services';
import { Coach, CoachesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-coach-details',
  templateUrl: './coach-details.component.html',
  styleUrls: ['./coach-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CoachDetailsComponent implements OnInit, OnDestroy {

  public coach: Coach = {};
  public coaches: Coach[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private coachesDataService: CoachesDataService,
    private coachesColumnsService: CoachesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Coach - Details');
        this.getCoach(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.coach !== 'undefined') {
      this.coach = this.dynamicDialogConfig.data.coach;
    }
    this.columns = this.coachesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getCoach(id: number): void {
    this.isLoading = true;
    this.coachesDataService.getCoach(id).subscribe((response: Coach|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.coach = response;
      }
    });
  }

  list() {
    this.router.navigate(['/coaches']);
  }

  add() {
    this.router.navigate(['/coaches/add']);
  }

  edit() {
    this.router.navigate(['/coaches/edit/' + this.coach.id]);
  }

}
@Component({
  selector: 'app-coach-details',
  templateUrl: './coach-details.component.html',
  styleUrls: ['./coach-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCoachDetailsComponent extends CoachDetailsComponent {
}

